import { useEffect, useState } from "react";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import GetIcon from "../../utils/Icon";
import Tabs from "../../Components/Tabs";
import ApiResponseBox from "../../Components/ApiResponseBox";
import { usePostWmsSettingDetailMutation, usePostWmsSettingUpdateMutation } from "../../store/api/settingapi";

const WmsSettingForm = () => {
  const [showError, setShowError] = useState(false);
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error");
  const [getSetting] = usePostWmsSettingDetailMutation();
  const [updateSetting] = usePostWmsSettingUpdateMutation();
  const [cartBinOptions, setCartBinOptions] = useState([]);
  const [BulkcartBinOptions, setBulkCartBinOptions] = useState([]);

  useEffect(() => {
    const getdata = async () => {
      try {
        const response = await getSetting().unwrap();
        console.log("check response of setting", response);
        const cartBinOptions = response.message.cart_bin?.map(bin => bin.warehouse) || [];


        setCartBinOptions(cartBinOptions);

        const BulkcartBinOptions = response.message.bulk_order_bin?.map(bin => bin.warehouse) || [];

        setBulkCartBinOptions(BulkcartBinOptions)
        setFormData({
          packingSlipRequired: response.message.packing_slip_required === 1,
          allowPicklistCreation: response.message.allow_creation_of_picklist_in_stock_shortage === 1,
          gateEntry: response.message.gate_entry === 1,
          defaultPurchaseBin: response.message.default_purchase_bin || '',
          defaultRejectedBin: response.message.default_rejected_bin || '',
          defaultPurchaseReturn: response.message.default_purchaes_return || '',
          defaultMfgFromBin: response.message.default_mfg_from_bin || '',
          defaultMfgToBin: response.message.default_mfg_to_bin || '',
          defaultRGPShipment: response.message.default_rgp_shipment || '',
          defaultRGPReceipt: response.message.default_rgp_receipt || '',
          defaultSalesReturn: response.message.default_sales_return || '',
          b2bBin: response.message.cart_bin || [],
          bulkOrderBin: response.message.bulk_order_bin?.[0]?.warehouse || '',
          serialNoSetup: response.message.serial_no_setup || 'Manual',
          // shipment_with_invoice: response.message.shipment_with_invoice == true ? 1 : 0,
          // shipment_without_invoice: response.message.shipment_without_invoice == true ? 1 : 0,
        });
      } catch (error) {
        console.log("error wms setting", error);
        setError('Failed to load settings');
        setptype('Error');
        setShowError(true);
      }
    }
    getdata();
  }, []);

  // Main form state
  const [formData, setFormData] = useState({
    packingSlipRequired: false,
    allowPicklistCreation: false,
    gateEntry: false,
    defaultPurchaseBin: '',
    defaultRejectedBin: '',
    defaultPurchaseReturn: '',
    defaultMfgFromBin: '',
    defaultMfgToBin: '',
    defaultRGPShipment: '',
    defaultRGPReceipt: '',
    defaultSalesReturn: '',
    b2bBin: '',
    bulkOrderBin: '',
    serialNoSetup: '',


    // shipment_with_invoice: false,
    // shipment_without_invoice: false,



  });

  console.log("check formd ata is here ", formData);

  const [fieldErrors, setFieldErrors] = useState({
    tab1: {},
    tab2: {}
  });

  const handleInputChange = (fieldName, value) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));

    // Clear error for this field if it exists
    if (fieldErrors.tab1[fieldName] || fieldErrors.tab2[fieldName]) {
      setFieldErrors(prev => {
        const tab = fieldName in prev.tab1 ? 'tab1' : 'tab2';
        return {
          ...prev,
          [tab]: {
            ...prev[tab],
            [fieldName]: false
          }
        };
      });
    }
  };

  const validateForm = () => {
    const newErrors = {
      tab1: {},
      tab2: {}
    };

    let isValid = true;
    setFieldErrors(newErrors);
    return isValid;
  };
  console.log(cartBinOptions, "cartBinOptions");


  const saveData = async () => {
    if (!validateForm()) {
      setError('Please fill all required fields');
      setptype('Error');
      setShowError(true);
      return;
    }

    try {
      // Prepare your payload here
      const payload = {
        gate_entry: formData.gateEntry == true ? 1 : 0,
        dpacking_slip_required: formData.packingSlipRequired == true ? 1 : 0,
        allow_creation_of_picklist_in_stock_shortage: formData.allowPicklistCreation == true ? 1 : 0,
        // default_warehouse: formData.defaultPurchaseBin,
        default_purchase_bin: formData.defaultPurchaseBin,
        default_rejected_bin: formData.defaultRejectedBin,
        default_purchaes_return: formData.defaultPurchaseReturn,
        default_sales_return: formData.defaultSalesReturn,
        cart_bin: cartBinOptions.map(warehouseName => ({
          warehouse: warehouseName
        })),
          bulk_order_bin: BulkcartBinOptions.map(warehouseName => ({
          warehouse: warehouseName
        })),
        // bulk_order_bin: [
        //     {
        //         warehouse: formData.bulkOrderBin,
        //     }
        // ],
        default_mfg_from_bin: formData.defaultMfgFromBin,
        default_mfg_to_bin: formData.defaultMfgToBin,
        default_rgp_shipment: formData.defaultRGPShipment,
        default_rgp_receipt: formData.defaultRGPReceipt,
        serial_no_setup: formData.serialNoSetup,

        // shipment_with_invoice: formData.shipment_with_invoice == true ? 1 : 0,
        // shipment_without_invoice: formData.shipment_without_invoice == true ? 1 : 0,
      }

      // Call your API here
      const response = await updateSetting(payload).unwrap();
      console.log("check api respons eis here bbbb", response);
      setError('Settings saved successfully');
      setptype('Success');
      setShowError(true);
    } catch (err) {
      console.error('Error saving settings:', err);
      setError('Error saving settings');
      setptype('Error');
      setShowError(true);
    }
  };

  return (
    <>
      <Tabs />
      <div className="d-flex justify-content-between px-1" style={{ background: "#fcfdfe" }}>
        <div className="d-flex align-items-center customizewidth">
          <p className="m-0 breadcrumb-item">Setting</p>
          <p className="m-0"> <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /> </p>
          <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79", fontSize: '' }}>
            WMS Settings
          </a>
        </div>
        <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }}>
          <p
            style={{ textDecoration: "none", display: "flex" }}
            className="custom-btn-00989 m-0"
            onClick={saveData}
          >
            <GetIcon iconName="LuFilePlus2" size={12} /> &nbsp;
            Save
          </p>
        </div>
      </div>
      <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
        <div className="d-flex justify-content-between align-items-end ">
          <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
              <a className="removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" href="javascript:void(0);">
                General Details <GetIcon iconName="MdKeyboardArrowDown" size={15} />
              </a>
            </li>
          </ul>
          <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
            <span style={{ position: 'relative', top: '-1px' }}>
              <GetIcon iconName="CgAttachment" size={12} />
            </span>
            <span className=" fw-semibold" style={{ color: "#391F84" }}>
              Attachments
            </span>
          </div>
        </div>
      </div>
      <div className="py-2" style={{ width: "100%", backgroundColor: "#fff" }}>
        <div className="row d-flex justify-content-between">
          <div className="col-12" >
            <div className="sidebarbox m-0 px-4 py-2">
              <Tab1
                formData={formData}
                handleChange={handleInputChange}
                errors={fieldErrors.tab1}
                cartBinOptions={cartBinOptions}
                setCartBinOptions={setCartBinOptions}
                BulkcartBinOptions={BulkcartBinOptions}
                setBulkCartBinOptions={setBulkCartBinOptions}

              />
              <Tab2
                formData={formData}
                handleChange={handleInputChange}
                errors={fieldErrors.tab2}
              />
            </div>
          </div>
        </div>
      </div>
      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </>
  );
};

export default WmsSettingForm;